// Animated smiling gold face whose eyes pop open into two cedi (₵) signs, shown when a Pro gets paid.
// Eyes open at EYES_OPEN_MS; the cha-ching sound and buzz are timed to that moment.
export const EYES_OPEN_MS = 380;
// The eyes blink again here; each opening fires a ₵ burst plus the cha-ching and buzz.
export const BLINK_MS = 1650;
export const BURST_TIMES = [EYES_OPEN_MS, BLINK_MS];

const CediEye = ({ x }) => (
  <g>
    {/* Closed eye (happy lid) before the reveal */}
    <path className="cedi-lid" d={`M${x - 11} 47q11 -9 22 0`} fill="none" stroke="#0F8A5F" strokeWidth="5.5" strokeLinecap="round" />
    <g className="cedi-eye">
      <path d={`M${x + 7.5} ${38.5}a11.5 11.5 0 1 0 0 17`} fill="none" stroke="#0F8A5F" strokeWidth="6.5" strokeLinecap="round" />
      <path d={`M${x} 31v31`} stroke="#0F8A5F" strokeWidth="5" strokeLinecap="round" />
    </g>
  </g>
);

// ₵ signs shoot out from behind the face and fade away each time the eyes open: [angle°, distance px, size, colour].
const COINS = [
  [-90, 84, 24, "#0F8A5F"], [-45, 90, 20, "#D4A853"], [0, 92, 22, "#0F8A5F"], [45, 90, 19, "#D4A853"],
  [90, 82, 20, "#0F8A5F"], [135, 90, 21, "#D4A853"], [180, 92, 22, "#0F8A5F"], [-135, 90, 19, "#D4A853"],
];

export default function CediWinkFace({ size = 100 }) {
  const k = size / 120; // ₵ burst scales with the face
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="cedi-wink-face">
      {/* Success ring draws around the face, Apple Pay style */}
      <svg viewBox="0 0 140 140" className="absolute pointer-events-none" style={{ inset: "-10%", width: "120%", height: "120%" }} aria-hidden="true">
        <circle className="cedi-ring" cx="70" cy="70" r="66" fill="none" stroke="#0F8A5F" strokeWidth="3" strokeLinecap="round" transform="rotate(-90 70 70)" />
      </svg>
      {BURST_TIMES.map((at, wave) => COINS.map(([deg, dist, px, color], i) => {
        const r = ((deg + wave * 22) * Math.PI) / 180;
        return (
          <span key={`${wave}-${deg}`} className="cedi-coin absolute left-1/2 top-1/2 font-bold leading-none"
            style={{ "--dx": `${Math.cos(r) * dist * k}px`, "--dy": `${Math.sin(r) * dist * k}px`, animationDelay: `${at + i * 25}ms`, color, fontSize: Math.round(px * k) }}
            aria-hidden="true">₵</span>
        );
      }))}
      <svg viewBox="0 0 120 120" className="cedi-face relative w-full h-full drop-shadow-[0_12px_24px_rgba(196,153,67,0.35)]" role="img" aria-label="Smiling face with cedi sign eyes">
        <defs>
          <radialGradient id="cedi-face-fill" cx="36%" cy="30%" r="78%">
            <stop offset="0%" stopColor="#FBEBC2" />
            <stop offset="50%" stopColor="#E6BE6A" />
            <stop offset="100%" stopColor="#C49943" />
          </radialGradient>
        </defs>
        <circle cx="60" cy="60" r="50" fill="url(#cedi-face-fill)" />
        <circle cx="60" cy="60" r="45" fill="none" stroke="#FFF6DD" strokeOpacity="0.8" strokeWidth="2.5" />
        <ellipse cx="44" cy="26" rx="16" ry="7" fill="#FFFFFF" opacity="0.35" />
        <CediEye x={41} />
        <CediEye x={79} />
        {/* Cheeks */}
        <ellipse cx="29" cy="72" rx="7" ry="4.5" fill="#4F988E" opacity="0.35" />
        <ellipse cx="91" cy="72" rx="7" ry="4.5" fill="#4F988E" opacity="0.35" />
        {/* Big smile */}
        <path d="M38 71c6 17 38 17 44 0" fill="#1C1C1E" stroke="#1C1C1E" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}
